import { FC, useCallback } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Modal } from '@frontend/design-system';
import { pendoTags } from '../../../../../../../../../shared/constants';
import { useCreateFormStepsStore } from '../../provider';

export interface UsageTermsStepFooterProps {
  onAccept: () => Promise<void>;
  onGoBack?: () => void;
}

const UsageTermsStepFooter: FC<UsageTermsStepFooterProps> = ({ onAccept, onGoBack }) => {
  const { t } = useTranslation('forms');
  const { areUsageTermsAccepted, setIsCreatingForm } = useCreateFormStepsStore([
    'areUsageTermsAccepted',
    'setIsCreatingForm',
  ]);

  const acceptAndContinueHandler = useCallback(async () => {
    setIsCreatingForm(true);
    await onAccept();
    setIsCreatingForm(false);
  }, [onAccept, setIsCreatingForm]);

  return (
    <Modal.Footer
      primary={{
        label: t('Accept & Continue'),
        onClick: acceptAndContinueHandler,
        trackingId: pendoTags.templateGallery.usageTerms.accept,
        disabled: !areUsageTermsAccepted,
      }}
      secondary={{
        label: t('Cancel'),
      }}
      tertiary={
        onGoBack
          ? {
              label: t('Back to preview'),
              iconName: 'caret-left-small',
              onClick: onGoBack,
              trackingId: pendoTags.templateGallery.usageTerms.goBackToPreview,
            }
          : undefined
      }
    />
  );
};

export default UsageTermsStepFooter;
